import React from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  ThemeProvider,
  createTheme,
  CssBaseline,
} from "@mui/material"; 
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { careers } from "../../assets";

const theme = createTheme({
  palette: {
    primary: {
      main: "#0f63a5",
    },
    background: {
      default: "#ffffff",
    },
    text: {
      primary: "#ffffff",
    },
  },

});

const Hero: React.FC = () => {
  // Hook-like data (inline)
  const heroData = {
    titleTop: "Don't Just Work",
    titleBottom: "Build a",
    highlight: "Legacy",
    ctaText: "See Opportunities",
    backgroundImage: careers, // put your image in public/images
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <Box
        sx={{
          height: "100vh",
          width: "100%",
          position: "relative",

          // 🔥 FIXED BACKGROUND
          backgroundImage: `url(${heroData.backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",

          display: "flex",
          alignItems: "center",
          color: "#fff",
        }}
      >
        {/* Overlay */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            // background:
            //   "linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.55))",
          }}
        />

      </Box>
    </ThemeProvider>
  );
};

export default Hero;